var cov_ou2wicbml = function () {
  var path = "/Users/spana/SHEIN/shineout/src/DatePicker/Text.tsx",
      hash = "8a40089d8995e3cf0de060beb1d401bbcbbcc14b",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/DatePicker/Text.tsx",
    statementMap: {
      "0": {
        start: {
          line: 10,
          column: 33
        },
        end: {
          line: 10,
          column: 37
        }
      },
      "1": {
        start: {
          line: 11,
          column: 0
        },
        end: {
          line: 18,
          column: 1
        }
      },
      "2": {
        start: {
          line: 15,
          column: 4
        },
        end: {
          line: 15,
          column: 36
        }
      },
      "3": {
        start: {
          line: 20,
          column: 21
        },
        end: {
          line: 22,
          column: 1
        }
      },
      "4": {
        start: {
          line: 30,
          column: 4
        },
        end: {
          line: 30,
          column: 16
        }
      },
      "5": {
        start: {
          line: 32,
          column: 4
        },
        end: {
          line: 32,
          column: 48
        }
      },
      "6": {
        start: {
          line: 33,
          column: 4
        },
        end: {
          line: 33,
          column: 50
        }
      },
      "7": {
        start: {
          line: 34,
          column: 4
        },
        end: {
          line: 34,
          column: 50
        }
      },
      "8": {
        start: {
          line: 35,
          column: 4
        },
        end: {
          line: 35,
          column: 58
        }
      },
      "9": {
        start: {
          line: 36,
          column: 4
        },
        end: {
          line: 36,
          column: 50
        }
      },
      "10": {
        start: {
          line: 40,
          column: 4
        },
        end: {
          line: 47,
          column: 5
        }
      },
      "11": {
        start: {
          line: 46,
          column: 6
        },
        end: {
          line: 46,
          column: 36
        }
      },
      "12": {
        start: {
          line: 51,
          column: 25
        },
        end: {
          line: 51,
          column: 35
        }
      },
      "13": {
        start: {
          line: 52,
          column: 4
        },
        end: {
          line: 52,
          column: 63
        }
      },
      "14": {
        start: {
          line: 56,
          column: 30
        },
        end: {
          line: 56,
          column: 40
        }
      },
      "15": {
        start: {
          line: 57,
          column: 4
        },
        end: {
          line: 57,
          column: 21
        }
      },
      "16": {
        start: {
          line: 58,
          column: 4
        },
        end: {
          line: 58,
          column: 40
        }
      },
      "17": {
        start: {
          line: 58,
          column: 23
        },
        end: {
          line: 58,
          column: 40
        }
      },
      "18": {
        start: {
          line: 62,
          column: 47
        },
        end: {
          line: 62,
          column: 57
        }
      },
      "19": {
        start: {
          line: 63,
          column: 16
        },
        end: {
          line: 63,
          column: 34
        }
      },
      "20": {
        start: {
          line: 64,
          column: 4
        },
        end: {
          line: 64,
          column: 67
        }
      },
      "21": {
        start: {
          line: 64,
          column: 61
        },
        end: {
          line: 64,
          column: 67
        }
      },
      "22": {
        start: {
          line: 65,
          column: 4
        },
        end: {
          line: 65,
          column: 29
        }
      },
      "23": {
        start: {
          line: 65,
          column: 23
        },
        end: {
          line: 65,
          column: 29
        }
      },
      "24": {
        start: {
          line: 66,
          column: 4
        },
        end: {
          line: 80,
          column: 5
        }
      },
      "25": {
        start: {
          line: 67,
          column: 6
        },
        end: {
          line: 67,
          column: 35
        }
      },
      "26": {
        start: {
          line: 69,
          column: 6
        },
        end: {
          line: 71,
          column: 7
        }
      },
      "27": {
        start: {
          line: 70,
          column: 8
        },
        end: {
          line: 70,
          column: 77
        }
      },
      "28": {
        start: {
          line: 73,
          column: 8
        },
        end: {
          line: 73,
          column: 114
        }
      },
      "29": {
        start: {
          line: 75,
          column: 6
        },
        end: {
          line: 78,
          column: 7
        }
      },
      "30": {
        start: {
          line: 77,
          column: 8
        },
        end: {
          line: 77,
          column: 37
        }
      },
      "31": {
        start: {
          line: 79,
          column: 6
        },
        end: {
          line: 79,
          column: 34
        }
      },
      "32": {
        start: {
          line: 84,
          column: 30
        },
        end: {
          line: 84,
          column: 40
        }
      },
      "33": {
        start: {
          line: 85,
          column: 4
        },
        end: {
          line: 85,
          column: 65
        }
      },
      "34": {
        start: {
          line: 85,
          column: 23
        },
        end: {
          line: 85,
          column: 65
        }
      },
      "35": {
        start: {
          line: 89,
          column: 30
        },
        end: {
          line: 89,
          column: 40
        }
      },
      "36": {
        start: {
          line: 90,
          column: 4
        },
        end: {
          line: 90,
          column: 66
        }
      },
      "37": {
        start: {
          line: 90,
          column: 39
        },
        end: {
          line: 90,
          column: 66
        }
      },
      "38": {
        start: {
          line: 94,
          column: 4
        },
        end: {
          line: 104,
          column: 5
        }
      },
      "39": {
        start: {
          line: 95,
          column: 6
        },
        end: {
          line: 95,
          column: 24
        }
      },
      "40": {
        start: {
          line: 96,
          column: 6
        },
        end: {
          line: 96,
          column: 25
        }
      },
      "41": {
        start: {
          line: 97,
          column: 6
        },
        end: {
          line: 97,
          column: 25
        }
      },
      "42": {
        start: {
          line: 98,
          column: 6
        },
        end: {
          line: 98,
          column: 31
        }
      },
      "43": {
        start: {
          line: 101,
          column: 6
        },
        end: {
          line: 103,
          column: 8
        }
      },
      "44": {
        start: {
          line: 102,
          column: 8
        },
        end: {
          line: 102,
          column: 73
        }
      },
      "45": {
        start: {
          line: 108,
          column: 74
        },
        end: {
          line: 108,
          column: 84
        }
      },
      "46": {
        start: {
          line: 109,
          column: 22
        },
        end: {
          line: 109,
          column: 53
        }
      },
      "47": {
        start: {
          line: 110,
          column: 22
        },
        end: {
          line: 110,
          column: 41
        }
      },
      "48": {
        start: {
          line: 111,
          column: 4
        },
        end: {
          line: 135,
          column: 5
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 13,
            column: 2
          },
          end: {
            line: 13,
            column: 3
          }
        },
        loc: {
          start: {
            line: 13,
            column: 7
          },
          end: {
            line: 16,
            column: 3
          }
        },
        line: 13
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 29,
            column: 2
          },
          end: {
            line: 29,
            column: 3
          }
        },
        loc: {
          start: {
            line: 29,
            column: 32
          },
          end: {
            line: 37,
            column: 3
          }
        },
        line: 29
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 39,
            column: 2
          },
          end: {
            line: 39,
            column: 3
          }
        },
        loc: {
          start: {
            line: 39,
            column: 43
          },
          end: {
            line: 48,
            column: 3
          }
        },
        line: 39
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 50,
            column: 2
          },
          end: {
            line: 50,
            column: 3
          }
        },
        loc: {
          start: {
            line: 50,
            column: 15
          },
          end: {
            line: 53,
            column: 3
          }
        },
        line: 50
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 55,
            column: 2
          },
          end: {
            line: 55,
            column: 3
          }
        },
        loc: {
          start: {
            line: 55,
            column: 35
          },
          end: {
            line: 59,
            column: 3
          }
        },
        line: 55
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 61,
            column: 2
          },
          end: {
            line: 61,
            column: 3
          }
        },
        loc: {
          start: {
            line: 61,
            column: 51
          },
          end: {
            line: 81,
            column: 3
          }
        },
        line: 61
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 83,
            column: 2
          },
          end: {
            line: 83,
            column: 3
          }
        },
        loc: {
          start: {
            line: 83,
            column: 54
          },
          end: {
            line: 86,
            column: 3
          }
        },
        line: 83
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 88,
            column: 2
          },
          end: {
            line: 88,
            column: 3
          }
        },
        loc: {
          start: {
            line: 88,
            column: 20
          },
          end: {
            line: 91,
            column: 3
          }
        },
        line: 88
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 93,
            column: 2
          },
          end: {
            line: 93,
            column: 3
          }
        },
        loc: {
          start: {
            line: 93,
            column: 55
          },
          end: {
            line: 105,
            column: 3
          }
        },
        line: 93
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 101,
            column: 29
          },
          end: {
            line: 101,
            column: 30
          }
        },
        loc: {
          start: {
            line: 101,
            column: 35
          },
          end: {
            line: 103,
            column: 7
          }
        },
        line: 101
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 107,
            column: 2
          },
          end: {
            line: 107,
            column: 3
          }
        },
        loc: {
          start: {
            line: 107,
            column: 11
          },
          end: {
            line: 136,
            column: 3
          }
        },
        line: 107
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 40,
            column: 4
          },
          end: {
            line: 47,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 40,
            column: 4
          },
          end: {
            line: 47,
            column: 5
          }
        }, {
          start: {
            line: 40,
            column: 4
          },
          end: {
            line: 47,
            column: 5
          }
        }],
        line: 40
      },
      "1": {
        loc: {
          start: {
            line: 41,
            column: 6
          },
          end: {
            line: 44,
            column: 76
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 41,
            column: 6
          },
          end: {
            line: 41,
            column: 42
          }
        }, {
          start: {
            line: 42,
            column: 6
          },
          end: {
            line: 42,
            column: 22
          }
        }, {
          start: {
            line: 43,
            column: 6
          },
          end: {
            line: 43,
            column: 18
          }
        }, {
          start: {
            line: 44,
            column: 7
          },
          end: {
            line: 44,
            column: 47
          }
        }, {
          start: {
            line: 44,
            column: 51
          },
          end: {
            line: 44,
            column: 75
          }
        }],
        line: 41
      },
      "2": {
        loc: {
          start: {
            line: 58,
            column: 4
          },
          end: {
            line: 58,
            column: 40
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 58,
            column: 4
          },
          end: {
            line: 58,
            column: 40
          }
        }, {
          start: {
            line: 58,
            column: 4
          },
          end: {
            line: 58,
            column: 40
          }
        }],
        line: 58
      },
      "3": {
        loc: {
          start: {
            line: 64,
            column: 4
          },
          end: {
            line: 64,
            column: 67
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 64,
            column: 4
          },
          end: {
            line: 64,
            column: 67
          }
        }, {
          start: {
            line: 64,
            column: 4
          },
          end: {
            line: 64,
            column: 67
          }
        }],
        line: 64
      },
      "4": {
        loc: {
          start: {
            line: 65,
            column: 4
          },
          end: {
            line: 65,
            column: 29
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 65,
            column: 4
          },
          end: {
            line: 65,
            column: 29
          }
        }, {
          start: {
            line: 65,
            column: 4
          },
          end: {
            line: 65,
            column: 29
          }
        }],
        line: 65
      },
      "5": {
        loc: {
          start: {
            line: 66,
            column: 4
          },
          end: {
            line: 80,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 66,
            column: 4
          },
          end: {
            line: 80,
            column: 5
          }
        }, {
          start: {
            line: 66,
            column: 4
          },
          end: {
            line: 80,
            column: 5
          }
        }],
        line: 66
      },
      "6": {
        loc: {
          start: {
            line: 69,
            column: 6
          },
          end: {
            line: 71,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 69,
            column: 6
          },
          end: {
            line: 71,
            column: 7
          }
        }, {
          start: {
            line: 69,
            column: 6
          },
          end: {
            line: 71,
            column: 7
          }
        }],
        line: 69
      },
      "7": {
        loc: {
          start: {
            line: 73,
            column: 8
          },
          end: {
            line: 73,
            column: 114
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 73,
            column: 37
          },
          end: {
            line: 73,
            column: 102
          }
        }, {
          start: {
            line: 73,
            column: 105
          },
          end: {
            line: 73,
            column: 114
          }
        }],
        line: 73
      },
      "8": {
        loc: {
          start: {
            line: 75,
            column: 6
          },
          end: {
            line: 78,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 75,
            column: 6
          },
          end: {
            line: 78,
            column: 7
          }
        }, {
          start: {
            line: 75,
            column: 6
          },
          end: {
            line: 78,
            column: 7
          }
        }],
        line: 75
      },
      "9": {
        loc: {
          start: {
            line: 85,
            column: 4
          },
          end: {
            line: 85,
            column: 65
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 85,
            column: 4
          },
          end: {
            line: 85,
            column: 65
          }
        }, {
          start: {
            line: 85,
            column: 4
          },
          end: {
            line: 85,
            column: 65
          }
        }],
        line: 85
      },
      "10": {
        loc: {
          start: {
            line: 90,
            column: 4
          },
          end: {
            line: 90,
            column: 66
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 90,
            column: 4
          },
          end: {
            line: 90,
            column: 66
          }
        }, {
          start: {
            line: 90,
            column: 4
          },
          end: {
            line: 90,
            column: 66
          }
        }],
        line: 90
      },
      "11": {
        loc: {
          start: {
            line: 90,
            column: 8
          },
          end: {
            line: 90,
            column: 37
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 90,
            column: 8
          },
          end: {
            line: 90,
            column: 21
          }
        }, {
          start: {
            line: 90,
            column: 25
          },
          end: {
            line: 90,
            column: 37
          }
        }],
        line: 90
      },
      "12": {
        loc: {
          start: {
            line: 94,
            column: 4
          },
          end: {
            line: 104,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 94,
            column: 4
          },
          end: {
            line: 104,
            column: 5
          }
        }, {
          start: {
            line: 94,
            column: 4
          },
          end: {
            line: 104,
            column: 5
          }
        }],
        line: 94
      },
      "13": {
        loc: {
          start: {
            line: 109,
            column: 22
          },
          end: {
            line: 109,
            column: 53
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 109,
            column: 22
          },
          end: {
            line: 109,
            column: 31
          }
        }, {
          start: {
            line: 109,
            column: 35
          },
          end: {
            line: 109,
            column: 44
          }
        }, {
          start: {
            line: 109,
            column: 48
          },
          end: {
            line: 109,
            column: 53
          }
        }],
        line: 109
      },
      "14": {
        loc: {
          start: {
            line: 113,
            column: 9
          },
          end: {
            line: 125,
            column: 16
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 114,
            column: 10
          },
          end: {
            line: 124,
            column: 12
          }
        }, {
          start: {
            line: 125,
            column: 12
          },
          end: {
            line: 125,
            column: 16
          }
        }],
        line: 113
      },
      "15": {
        loc: {
          start: {
            line: 115,
            column: 19
          },
          end: {
            line: 115,
            column: 53
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 115,
            column: 32
          },
          end: {
            line: 115,
            column: 41
          }
        }, {
          start: {
            line: 115,
            column: 44
          },
          end: {
            line: 115,
            column: 53
          }
        }],
        line: 115
      },
      "16": {
        loc: {
          start: {
            line: 127,
            column: 17
          },
          end: {
            line: 127,
            column: 50
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 127,
            column: 29
          },
          end: {
            line: 127,
            column: 38
          }
        }, {
          start: {
            line: 127,
            column: 41
          },
          end: {
            line: 127,
            column: 50
          }
        }],
        line: 127
      },
      "17": {
        loc: {
          start: {
            line: 130,
            column: 32
          },
          end: {
            line: 130,
            column: 67
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 130,
            column: 32
          },
          end: {
            line: 130,
            column: 38
          }
        }, {
          start: {
            line: 130,
            column: 42
          },
          end: {
            line: 130,
            column: 67
          }
        }],
        line: 130
      },
      "18": {
        loc: {
          start: {
            line: 132,
            column: 11
          },
          end: {
            line: 132,
            column: 31
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 132,
            column: 11
          },
          end: {
            line: 132,
            column: 16
          }
        }, {
          start: {
            line: 132,
            column: 20
          },
          end: {
            line: 132,
            column: 31
          }
        }],
        line: 132
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0, 0, 0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0],
      "13": [0, 0, 0],
      "14": [0, 0],
      "15": [0, 0],
      "16": [0, 0],
      "17": [0, 0],
      "18": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
var _jsxFileName = "/Users/spana/SHEIN/shineout/src/DatePicker/Text.tsx";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React, { PureComponent } from 'react';
import classnames from 'classnames';
import { inputClass } from '../Input/styles';
import { getParent, focusElement } from '../utils/dom/element';
import utils from './utils';
import { datepickerClass } from './styles';
import { getLocale } from '../locale';
var target = (cov_ou2wicbml.s[0]++, null);
cov_ou2wicbml.s[1]++;
document.addEventListener('mousedown', function (e) {
  cov_ou2wicbml.f[0]++;
  cov_ou2wicbml.s[2]++;
  // eslint-disable-next-line prefer-destructuring
  target = e.target;
}, true);
var DefaultValue = (cov_ou2wicbml.s[3]++, {
  value: ''
});

var Text =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Text, _PureComponent);

  var _super = _createSuper2(Text);

  function Text(props) {
    var _this;

    _classCallCheck(this, Text);

    cov_ou2wicbml.f[1]++;
    cov_ou2wicbml.s[4]++;
    _this = _super.call(this, props);
    _this.element = void 0;
    cov_ou2wicbml.s[5]++;
    _this.handleBlur = _this.handleBlur.bind(_assertThisInitialized(_this));
    cov_ou2wicbml.s[6]++;
    _this.handleInput = _this.handleInput.bind(_assertThisInitialized(_this));
    cov_ou2wicbml.s[7]++;
    _this.handleFocus = _this.handleFocus.bind(_assertThisInitialized(_this));
    cov_ou2wicbml.s[8]++;
    _this.handleSpanClick = _this.handleSpanClick.bind(_assertThisInitialized(_this));
    cov_ou2wicbml.s[9]++;
    _this.bindElement = _this.bindElement.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Text, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      cov_ou2wicbml.f[2]++;
      cov_ou2wicbml.s[10]++;

      if ((cov_ou2wicbml.b[1][0]++, prevProps.focus !== this.props.focus) && (cov_ou2wicbml.b[1][1]++, this.props.focus) && (cov_ou2wicbml.b[1][2]++, this.element) && ((cov_ou2wicbml.b[1][3]++, this.props.focusElement === this.element) || (cov_ou2wicbml.b[1][4]++, !this.props.focusElement))) {
        cov_ou2wicbml.b[0][0]++;
        cov_ou2wicbml.s[11]++;
        focusElement.end(this.element);
      } else {
        cov_ou2wicbml.b[0][1]++;
      }
    }
  }, {
    key: "getOptions",
    value: function getOptions() {
      cov_ou2wicbml.f[3]++;

      var _ref = (cov_ou2wicbml.s[12]++, this.props),
          timeZone = _ref.timeZone;

      cov_ou2wicbml.s[13]++;
      return {
        timeZone: timeZone,
        weekStartsOn: getLocale('startOfWeek')
      };
    }
  }, {
    key: "bindElement",
    value: function bindElement(el) {
      cov_ou2wicbml.f[4]++;

      var _ref2 = (cov_ou2wicbml.s[14]++, this.props),
          onTextSpanRef = _ref2.onTextSpanRef;

      cov_ou2wicbml.s[15]++;
      this.element = el;
      cov_ou2wicbml.s[16]++;

      if (onTextSpanRef) {
        cov_ou2wicbml.b[2][0]++;
        cov_ou2wicbml.s[17]++;
        onTextSpanRef(el);
      } else {
        cov_ou2wicbml.b[2][1]++;
      }
    }
  }, {
    key: "handleBlur",
    value: function handleBlur(e) {
      cov_ou2wicbml.f[5]++;

      var _ref3 = (cov_ou2wicbml.s[18]++, this.props),
          format = _ref3.format,
          index = _ref3.index,
          onChange = _ref3.onChange,
          value = _ref3.value;

      var txt = (cov_ou2wicbml.s[19]++, e.target.innerText);
      cov_ou2wicbml.s[20]++;

      if (getParent(target, ".".concat(datepickerClass('picker')))) {
        cov_ou2wicbml.b[3][0]++;
        cov_ou2wicbml.s[21]++;
        return;
      } else {
        cov_ou2wicbml.b[3][1]++;
      }

      cov_ou2wicbml.s[22]++;

      if (txt === value) {
        cov_ou2wicbml.b[4][0]++;
        cov_ou2wicbml.s[23]++;
        return;
      } else {
        cov_ou2wicbml.b[4][1]++;
      }

      cov_ou2wicbml.s[24]++;

      if (txt.trim().length === 0) {
        cov_ou2wicbml.b[5][0]++;
        cov_ou2wicbml.s[25]++;
        onChange(undefined, index, e);
      } else {
        cov_ou2wicbml.b[5][1]++;
        cov_ou2wicbml.s[26]++;

        if (typeof format !== 'string') {
          cov_ou2wicbml.b[6][0]++;
          cov_ou2wicbml.s[27]++;
          console.error('formatResult should be string when inputable is true');
        } else {
          cov_ou2wicbml.b[6][1]++;
        }

        var newValue = (cov_ou2wicbml.s[28]++, typeof format === 'string' ? (cov_ou2wicbml.b[7][0]++, utils.toDateWithFormat(txt, format, undefined, this.getOptions())) : (cov_ou2wicbml.b[7][1]++, undefined)); // if translate fail, clear

        cov_ou2wicbml.s[29]++;

        if (!newValue) {
          cov_ou2wicbml.b[8][0]++;
          cov_ou2wicbml.s[30]++;
          // @ts-ignore
          this.element.innerText = null;
        } else {
          cov_ou2wicbml.b[8][1]++;
        }

        cov_ou2wicbml.s[31]++;
        onChange(newValue, index, e);
      }
    }
  }, {
    key: "handleFocus",
    value: function handleFocus(e) {
      cov_ou2wicbml.f[6]++;

      var _ref4 = (cov_ou2wicbml.s[32]++, this.props),
          onTextSpanRef = _ref4.onTextSpanRef;

      cov_ou2wicbml.s[33]++;

      if (onTextSpanRef) {
        cov_ou2wicbml.b[9][0]++;
        cov_ou2wicbml.s[34]++;
        onTextSpanRef(e.target);
      } else {
        cov_ou2wicbml.b[9][1]++;
      }
    }
  }, {
    key: "handleSpanClick",
    value: function handleSpanClick() {
      cov_ou2wicbml.f[7]++;

      var _ref5 = (cov_ou2wicbml.s[35]++, this.props),
          onTextSpanRef = _ref5.onTextSpanRef;

      cov_ou2wicbml.s[36]++;

      if ((cov_ou2wicbml.b[11][0]++, onTextSpanRef) && (cov_ou2wicbml.b[11][1]++, this.element)) {
        cov_ou2wicbml.b[10][0]++;
        cov_ou2wicbml.s[37]++;
        onTextSpanRef(this.element);
      } else {
        cov_ou2wicbml.b[10][1]++;
      }
    }
  }, {
    key: "handleInput",
    value: function handleInput(e) {
      cov_ou2wicbml.f[8]++;
      cov_ou2wicbml.s[38]++;

      if (e.keyCode === 13) {
        cov_ou2wicbml.b[12][0]++;
        cov_ou2wicbml.s[39]++;
        e.preventDefault();
        cov_ou2wicbml.s[40]++;
        e.stopPropagation();
        cov_ou2wicbml.s[41]++;
        this.element.blur();
        cov_ou2wicbml.s[42]++;
        this.handleBlur(e); // must wait for handleBlur to finish executing

        cov_ou2wicbml.s[43]++;
        Promise.resolve().then(function () {
          cov_ou2wicbml.f[9]++;
          cov_ou2wicbml.s[44]++;
          document.dispatchEvent(new Event('mousedown', {
            bubbles: true
          }));
        });
      } else {
        cov_ou2wicbml.b[12][1]++;
      }
    }
  }, {
    key: "render",
    value: function render() {
      cov_ou2wicbml.f[10]++;

      var _ref6 = (cov_ou2wicbml.s[45]++, this.props),
          className = _ref6.className,
          inputable = _ref6.inputable,
          value = _ref6.value,
          placeholder = _ref6.placeholder,
          disabled = _ref6.disabled,
          focus = _ref6.focus;

      var showInput = (cov_ou2wicbml.s[46]++, (cov_ou2wicbml.b[13][0]++, inputable) && (cov_ou2wicbml.b[13][1]++, !disabled) && (cov_ou2wicbml.b[13][2]++, focus));
      var hideStyle = (cov_ou2wicbml.s[47]++, {
        display: 'none'
      });
      cov_ou2wicbml.s[48]++;
      return (
        /*#__PURE__*/
        React.createElement(React.Fragment, null, inputable ? (cov_ou2wicbml.b[14][0]++,
        /*#__PURE__*/
        React.createElement("span", {
          style: !showInput ? (cov_ou2wicbml.b[15][0]++, hideStyle) : (cov_ou2wicbml.b[15][1]++, undefined),
          ref: this.bindElement,
          key: "edit",
          contentEditable: inputable,
          onBlur: this.handleBlur,
          onFocus: this.handleFocus,
          onKeyDown: this.handleInput,
          className: className,
          dangerouslySetInnerHTML: {
            __html: value
          },
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 114,
            columnNumber: 11
          }
        })) : (cov_ou2wicbml.b[14][1]++, null),
        /*#__PURE__*/
        React.createElement("span", {
          style: showInput ? (cov_ou2wicbml.b[16][0]++, hideStyle) : (cov_ou2wicbml.b[16][1]++, undefined),
          key: "placeholder",
          onClick: this.handleSpanClick,
          className: classnames((cov_ou2wicbml.b[17][0]++, !value) && (cov_ou2wicbml.b[17][1]++, inputClass('placeholder')), className),
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 126,
            columnNumber: 9
          }
        }, (cov_ou2wicbml.b[18][0]++, value) || (cov_ou2wicbml.b[18][1]++, placeholder)))
      );
    }
  }]);

  return Text;
}(PureComponent);

Text.defaultProps = DefaultValue;
export default Text;